import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import HubspotIcon from './hubspot-icon.svg'
import IntegrationAppIcon from './integration-app.svg'
import clsx from 'clsx'
import classes from './MostExtensiveFramework.module.scss'

export const MostExtensiveFramework = () => {
  return (
    <Block as={'section'} divider={'full'} className={classes.section}>
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        The most extensive connector framework on the market
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        Embedded iPaaSes give you only triggers and actions. Unified APls only
        give you universal data models. We give you all of these things, full
        metadata about them, and more. You can do an order of magnitude more
        things through our connectors.
      </Text>

      <div className={classes.other_connectorsMob}>
        <div className={classes.grid_titleWrap}>
          <img
            src={HubspotIcon.src}
            alt='Hubspot'
            width={24}
            height={24}
            loading='lazy'
          />
          <Text as={'span'} lh={'relaxed'} className={classes.grid_title}>
            Hubspot Connector
          </Text>
        </div>
        <div className={classes.grid_wrap}>
          <div className={classes.grid}>
            <Text lh={'relaxed'} as={'span'} className={classes.grid__item}>
              Leading Embedded iPaas
            </Text>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Operations
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                61
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Data Collections
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                11
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Events
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                1
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Universal Data Models
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                0
              </Text>
            </div>
          </div>
        </div>
        <div className={classes.grid_wrap}>
          <div className={classes.grid}>
            <Text lh={'relaxed'} as={'span'} className={classes.grid__item}>
              Leading Unified API
            </Text>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Operations
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                36
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Data Collections
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                8
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Events
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                0
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Universal Data Models
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                8
              </Text>
            </div>
          </div>
        </div>
        <div className={clsx(classes.grid_wrap, classes.grid_wrapHighlighted)}>
          <div className={classes.grid}>
            <div className={classes.grid__item}>
              <div className={classes.icon_wrap}>
                <img
                  src={IntegrationAppIcon.src}
                  alt='Integration App'
                  width={32}
                  height={19}
                  loading='lazy'
                />
                Integration App
              </div>
            </div>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Operations
              </Text>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemNumber}
              >
                645
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                lh={'relaxed'}
                as={'span'}
                className={classes.grid__itemText}
              >
                Data Collections
              </Text>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                28
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemText}
              >
                Events
              </Text>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                85
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemText}
              >
                Universal Data Models
              </Text>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                11
              </Text>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.other_connectorsDesk}>
        <div className={clsx(classes.grid_wrap, classes.grid_wrapDesk)}>
          <div className={classes.grid}>
            <div className={classes.grid__item}>
              <div className={classes.icon_wrap}>
                <img
                  src={HubspotIcon.src}
                  alt='Hubspot'
                  width={24}
                  height={24}
                  loading='lazy'
                />
                <Text as={'span'} lh={'relaxed'} className={classes.grid_title}>
                  Hubspot Connector
                </Text>
              </div>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemText}
              >
                Operations
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemText}
              >
                Data Collections
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemText}
              >
                Events
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemText}
              >
                Universal Data Models
              </Text>
            </div>
          </div>
          <div className={classes.grid}>
            <Text as={'span'} className={classes.grid__item}>
              Leading Embedded iPaas
            </Text>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                61
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                11
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                1
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                0
              </Text>
            </div>
          </div>
          <div className={classes.grid}>
            <Text as={'span'} lh={'relaxed'} className={classes.grid__item}>
              Leading Unified API
            </Text>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                36
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                8
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                0
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                8
              </Text>
            </div>
          </div>
        </div>
        <div className={clsx(classes.grid_wrap, classes.grid_wrapHighlighted)}>
          <div className={classes.grid}>
            <div className={classes.grid__item}>
              <div className={classes.icon_wrap}>
                <img
                  src={IntegrationAppIcon.src}
                  alt='Integration App'
                  width={32}
                  height={19}
                  loading='lazy'
                />
                Integration App
              </div>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                645
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                28
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                85
              </Text>
            </div>
            <div className={classes.grid__item}>
              <Text
                as={'span'}
                lh={'relaxed'}
                className={classes.grid__itemNumber}
              >
                11
              </Text>
            </div>
          </div>
        </div>
      </div>
    </Block>
  )
}
